import React from 'react';
import { useDispatch } from 'react-redux';
import { formatNumber } from '../../Utils/Utils';
import {
  DataCellCrumbtrailContainer,
  DataCellCrumbtrailItem,
  DataCellCrumbtrailSeparator,
  DataCellNumberContainer,
  DataCellYesNoContainer,
  DataCellNumberValue,
  DataCellLabel,
} from './DataCellsCSS';
import ObjectActionCreators from '../../../actions';

export const DataCellCrumbtrail = ({ value, crumbtrailIds }) => {
  const valueTrimed = value?.trim();
  const cleanedChain = valueTrimed.endsWith('>')
    ? valueTrimed.slice(0, -1)
    : valueTrimed;
  const crumbElems = cleanedChain?.split('>');
  const crumbIdElems = crumbtrailIds?.split('|');
  const dispatch = useDispatch();

  const handleClickCrumb = (e, index) => {
    e.stopPropagation();
    dispatch(ObjectActionCreators.selectObject(crumbIdElems[index]));
  };

  return (
    <DataCellCrumbtrailContainer>
      {crumbElems?.map((text, index) => (
        <React.Fragment key={index}>
          <DataCellCrumbtrailItem onClick={(e) => handleClickCrumb(e, index)}>
            {text?.length > 15 ? `${text.substr(0, 15)}...` : text}
          </DataCellCrumbtrailItem>
          {index < crumbElems.length - 1 && (
            <DataCellCrumbtrailSeparator>►</DataCellCrumbtrailSeparator>
          )}
        </React.Fragment>
      ))}
    </DataCellCrumbtrailContainer>
  );
};

export const DataCellYesNo = ({ color }) => {
  return (
    <DataCellYesNoContainer>
      <svg opacity="1">
        <circle
          cx="10"
          cy="27"
          r="14"
          fill={`var(--ds-bg-secondary)`}
          stroke="#222"
          fillOpacity="0.3"
          strokeOpacity="0.3"
        />
        <circle
          cx="10"
          cy="27"
          r="8"
          fill={color}
          stroke="#333"
          fillOpacity="1"
        />
      </svg>
    </DataCellYesNoContainer>
  );
};

export const DataCellNumber = React.memo(
  ({ value, onClick, refValue, unit = '', label, isStacked }) => {
    const { r, fill } = React.useMemo(() => {
      const v = Number(value);
      const rV = Number(refValue);
      if (!rV || !v) return { r: 0, fill: 'transparent' };
      const ratio = Math.max(0, Math.min(1, v / rV));
      return {
        r: Math.min(10, 10 * ratio ** 0.7),
        fill: v <= rV ? 'var(--ds-base)' : 'red',
      };
    }, [value, refValue]);
    return (
      <DataCellNumberContainer
        onMouseUp={(e) => {
          e.stopPropagation();
        }}
        onClick={onClick}
      >
        {isStacked && <DataCellLabel>{label}:</DataCellLabel>}
        <DataCellNumberValue $isStacked={isStacked}>
          {formatNumber(value) || ''}
          {unit}
        </DataCellNumberValue>
        <div style={{ width: '20px', height: '20px' }}>
          <svg opacity="1" height="20" width="20">
            <circle
              cx="10"
              cy="10"
              r="10"
              fill={`var(--ds-bg-secondary)`}
              strokeOpacity="0"
              fillOpacity="1"
            />
            {!!r && (
              <circle cx="10" cy="10" r={r} fill={fill} fillOpacity="1" />
            )}
          </svg>
        </div>
      </DataCellNumberContainer>
    );
  }
);
